<template>
  <div>
    <Loader v-if="loading" />

    <p class="center" v-else-if="!records.length">
      {{'NoRecords' | localize}}.
      <router-link to="/record">{{'AddFirst' | localize}}</router-link>
    </p>
    <div v-else>
      <div class="page-title">
        <h3>{{'History_Title' | localize}}</h3>
      </div>

      <HistoryChart
        :ChartRecords="records"
        :ChartCategories="categories"
        :key="categories.length + refreshCount"
      />

      <section>
        <RecordHistory
          :HistoryRecords="items"
          :HistoryCategories="categories"
          :key="categories.length + refreshCount"
          @recordDelete="refresh"
        />
        <Paginate
          v-model="page"
          :page-count="pageCount"
          :click-handler="pageChangeHandler"
          :prev-text="'Back' | localize"
          :next-text="'Forward' | localize"
          :container-class="'pagination'"
          :page-class="'waves-effect'"
        />
      </section>
    </div>
  </div>
</template>

<style scoped>
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 50px;
}
</style>

<script>
import RecordHistory from "@/components/app/RecordHistory";
import HistoryChart from "@/components/app/HistoryChart";
import paginationMixin from "@/mixins/pagination.mixin";

export default {
  name: "History",
  metaInfo() {
    return {
      title: this.$title("Menu_History")
    };
  },
  mixins: [paginationMixin],
  data: () => ({
    records: [],
    categories: [],
    loading: true,
    refreshCount: 0
  }),
  components: {
    RecordHistory,
    HistoryChart
  },
  async mounted() {
    this.categories = await this.$store.dispatch("fetchCategories");
    this.records = await this.$store.dispatch("fetchRecords");

    this.setupPagination(this.records);

    this.loading = false;
  },
  methods: {
    async refresh() {
      this.records = await this.$store.dispatch("fetchRecords");
      this.setupPagination(this.records);
      this.refreshCount++;
    }
  }
};
</script>